import { h } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { ChannelCard } from './ChannelCard.jsx'
import { listWidgetConversations } from '../beacon-api.js'
import { formatRelativeTime } from '../beacon-utils.js'
import { t } from '../beacon-i18n.js'

// Preview shows at most this many recent AI conversations below the channel
// cards — enough to be useful without pushing the panel height too far.
const HISTORY_PREVIEW_LIMIT = 3

/**
 * HomeScreen — the widget's landing screen: 3 channel cards over the purple
 * gradient header, followed by a "Korábbi beszélgetések" preview.
 *
 * The preview only renders when the user actually has at least one previous
 * AI conversation started from this widget (Ai::Conversation#source ==
 * 'beacon') — email threads do NOT count here and are never shown in this
 * preview, since starting a new email already has its own "E-mail" channel
 * card above. No badge/unread count (no live agent conversations exist).
 */
export function HomeScreen({ store }) {
  const [chatHistory, setChatHistory] = useState([])

  useEffect(() => {
    let cancelled = false

    listWidgetConversations()
      .then((list) => {
        if (cancelled) return
        const chatOnly = (Array.isArray(list) ? list : []).filter((item) => item.type === 'ai')
        setChatHistory(chatOnly.slice(0, HISTORY_PREVIEW_LIMIT))
      })
      .catch(() => {
        if (!cancelled) setChatHistory([])
      })

    return () => { cancelled = true }
  }, [])

  return (
    <div class="beacon-home">
      <div class="beacon-channel-cards">
        <ChannelCard
          index={0}
          icon="bi-stars"
          iconVariant="gradient"
          title={t('support.beacon.home.ai_card.title')}
          subtitle={t('support.beacon.home.ai_card.subtitle')}
          onClick={() => store.openAiFromHome()}
        />
        <ChannelCard
          index={1}
          icon="bi-search"
          iconVariant="solid"
          title={t('support.beacon.home.guide_card.title')}
          subtitle={t('support.beacon.home.guide_card.subtitle')}
          onClick={() => store.navigateTo('guide')}
        />
        <ChannelCard
          index={2}
          icon="bi-envelope"
          iconVariant="solid"
          title={t('support.beacon.home.email_card.title')}
          subtitle={t('support.beacon.home.email_card.subtitle')}
          onClick={() => store.navigateTo('email')}
        />
      </div>

      {chatHistory.length > 0 && (
        <div class="beacon-home-history">
          <button type="button" class="beacon-history-link" onClick={() => store.navigateTo('conversations')}>
            {t('support.beacon.home.history_link')}
          </button>

          <div class="beacon-home-history-cards">
            {chatHistory.map((conversation, index) => (
              <button
                key={conversation.agent_id || conversation.id}
                type="button"
                class="beacon-home-history-card"
                style={`--beacon-card-delay: ${index * 70}ms`}
                onClick={() => store.openAiConversation(conversation.agent_id)}
              >
                <span class="beacon-home-history-icon">
                  <i class="bi bi-stars"></i>
                </span>
                <span class="beacon-home-history-text">
                  <span class="beacon-home-history-title">{conversation.title}</span>
                  <span class="beacon-home-history-snippet">{conversation.snippet}</span>
                </span>
                <span class="beacon-home-history-time">{formatRelativeTime(conversation.updated_at)}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
